export const reallyTruthy = bool => {
  if (
    !bool ||
    bool === 'false' ||
    bool === '0' ||
    bool === [] ||
    bool === {} ||
    bool === 'undefined'
  ) {
    return false
  } else {
    return true
  }
}
